import {SVGAttributes} from 'react';

type LogoIconProps = SVGAttributes<SVGElement> & {
    tooltip?: string;
};

export default function LogoIcon({tooltip, ...props}: LogoIconProps) {
    return (
        <div className="relative inline-block group">
            <svg
                {...props}
                className="w-7 h-7 mr-2"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Top curve of the 'S' (Vibrant Orange) */}
                <rect x="42" y="16" width="42" height="12" rx="6" fill="#FF8E00" />

                {/* Diagonal moving down-left (Vibrant Orange) */}
                <rect x="16" y="36" width="48" height="12" rx="6" fill="#FF8E00" />

                {/* Diagonal moving down-right (Light Orange) */}
                <rect x="36" y="56" width="48" height="12" rx="6" fill="#F8B660" />

                {/* Bottom curve of the 'S' (Light Orange) */}
                <rect x="16" y="76" width="42" height="12" rx="6" fill="#F8B660" />
            </svg>
            {tooltip && (
                <div
                    className="absolute top-full left-1/2 -translate-x-1/2 mt-2
                        pointer-events-none opacity-0 group-hover:opacity-100
                        transition-opacity duration-200 delay-300 z-50 whitespace-nowrap
                        px-3 py-1.5 text-xs font-medium rounded-lg
                        bg-white text-gray-900 dark:bg-gray-900 dark:text-white
                        shadow-lg border border-gray-200 dark:border-gray-700"
                >
                    {tooltip}
                </div>
            )}
        </div>
    );
}
